<template>
  <v-btn @click="callGenerateReport" :disabled="loading" color="primary" elevation="0">
    <v-progress-circular v-if="loading" :size="14" :width="2" color="grey lighten-1" class="mr-2" indeterminate />
    <v-icon v-else left>mdi-download-box-outline</v-icon>
    <span class="d-none d-md-flex body-2">
      {{ $t('payment.list.actions.hostPendingInvoicesReport') }}
    </span>
  </v-btn>
</template>

<script>
import { generatePendingInvoicesReport } from '@/views/invoices/hauseful/invoiceService'

export default {
  name: 'PaymentHeaderActions',

  methods: {
    callGenerateReport() {
      this.loading = true

      generatePendingInvoicesReport()
        .then((response) => this.generateExcel(response))
        .catch((error) => this.$store.commit('setToasterMessage', error.message))
        .finally(() => (this.loading = false))
    },

    generateExcel(response) {
      let blob = new Blob([response.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
      let url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', 'relatorio_de_notas_fiscais_pendentes.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },

  data() {
    return {
      loading: false,
    }
  },
}
</script>
